import React, { useContext, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Col, Row } from "react-bootstrap"
import { isNullUndefinedOrEmpty } from "../../../common/Helpers";
import MessageBox from "../../../components/Common/Message/MessageBox";
import { __MessageTypes } from "../../../common/Dictionaries";
import MainAppContext from "../../../MainAppContext";
import JqxDropDownList from 'jqwidgets-scripts/jqwidgets-react-tsx/jqxdropdownlist';
import { ActionButton, CommandBarButton, PrimaryButton } from "@fluentui/react";
import { useDispatch } from "react-redux";
import CLabel from "../../Common/CLabel";
import { action_setSelectedFilterContractList, action_setSelectedFilterIndexList, action_setSelectedFilterPeriod } from "../../../reducers/actions/Adjustment/actions";
import JqxNumberInput from "jqwidgets-scripts/jqwidgets-react-tsx/jqxnumberinput";
import JqxDateTimeInput from 'jqwidgets-scripts/jqwidgets-react-tsx/jqxdatetimeinput';
import moment from "moment";

export default function HeaderFilters(props) {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const contextSite = useContext(MainAppContext);
    const profileHasAccess = !contextSite.onlyObserver || (contextSite.securityProps.isSAdmin ||  contextSite.securityProps.isAdmin)
    
    const refDDL_Index = useRef(null)
	const refDDL_Contract = useRef(null);

    const [amount, setAmount] = useState(null);

    const handleOnSelectIndexFilter = (event) => {
        if (event.args) {
            const selectedItem = event.args.item;

            if (selectedItem) {
                const items = !isNullUndefinedOrEmpty(refDDL_Index.current) ? refDDL_Index.current.getCheckedItems() : [];
                dispatch(action_setSelectedFilterIndexList(items))
            }
        }
    };

    const handleOnSelectContractFilter = (event) => {
        if (event.args) {
            const selectedItem = event.args.item;

            if (selectedItem) {
                const items = !isNullUndefinedOrEmpty(refDDL_Contract.current) ? refDDL_Contract.current.getCheckedItems() : [];
                dispatch(action_setSelectedFilterContractList(items))
            }
        }
    };

    const handleOnAddFilters = (event) => {

    };

    const handleOnCalculateGeneral = () => {

    };

    const onChangeAmount = (value) =>{
        setAmount(value)
    }

    const onChangeSelectedPeriod = (event) =>{
        dispatch(action_setSelectedFilterPeriod(moment(event.args.date).format('DD/MM/YYYY')))
    }

    return (
        <Row>
            <Col>
            </Col>
            <Col className={"col-auto ms-auto"}>
                <Row>
                    <Col>
                    </Col>
                    <Col className={"col-auto ms-auto"}>
                    {
                        props.filter_Index && props.showIndexFilter &&
                        <>
                            <CLabel labelText={t('data-lang-lbl-indexs')} />
                            <JqxDropDownList ref={refDDL_Index} onSelect={handleOnSelectIndexFilter}
                                width={200} height={30} source={props.filter_Index} checkboxes={props.multiFilterSelection}
                                displayMember={'name'} valueMember={'id'}
                            />
                        </>
                    }
                    </Col>
                    <Col className={"col-auto ms-auto"}>
                    {
                        props.filter_Contract &&
                        <>
                            <CLabel labelText={t('data-lang-lbl-contracts')} />
                            <JqxDropDownList ref={refDDL_Contract} onSelect={handleOnSelectContractFilter}
                                width={200} height={30} source={props.filter_Contract} checkboxes={props.multiFilterSelection}
                                displayMember={'name'} valueMember={'id'}
                            />
                        </>
                    }
                    </Col>
                    <Col className={"col-auto ms-auto d-flex"}>
                    {
                        props.filter_Index && props.filter_Contract &&
                        <>
                            {
                                props.showAdd &&
                                <ActionButton iconProps={{iconName: "Add"}} text={t('data-lang-btn-addfilterpolynomies')} onClick={handleOnAddFilters} />
                            }
                            <Row>
                                <Col>
                                    <Row>
                                        <Col>
                                            <ActionButton iconProps={{iconName: 'Calculator'}} className='w-100 px-0' onClick={ handleOnCalculateGeneral }>{ t('data-lang-btn-calculate') }</ActionButton>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <CLabel labelText={ t('data-lang-lbl-amount') } />
                                            <JqxNumberInput
                                                height={25}
                                                width={"100%"}
                                                decimalDigits={5}
                                                digits={12}
                                                symbolPosition={'right'}
                                                value={amount}
                                                groupSeparator= ','
                                                decimalSeparator= '.'
                                                onChange={(event) => onChangeAmount(event.args.value)}
                                                className='adjustment-calculated-amount'
                                            />
                                        </Col>
                                    </Row>
                                </Col>
                                <Col>
                                    <CLabel labelText={ t('data-lang-lbl-period') } />
                                    <JqxDateTimeInput width={320} height={25} onChange={onChangeSelectedPeriod} />
                                </Col>
                            </Row>
                        </>
                    }
                    </Col>
                </Row>
            </Col>
        </Row>
    ); 
}

